// src/hooks/useFileFetcher.js
import { useState } from 'react';
import { getSignedUrl, isUrlExpired } from '../helpers/S3Helpers';
import { GET_SIGNED_URL_PATH } from "../constants/ApiConstants";

function useFileFetcher() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchFile = async (resource_type, resourceName, fileName) => {
    setLoading(true);
    setError(null);

    try {
      const signedUrl = await getSignedUrl(GET_SIGNED_URL_PATH, resource_type, resourceName, fileName);

      if (!signedUrl || isUrlExpired(signedUrl)) {
        throw new Error("Failed to get a valid signed URL from the backend.");
      }

      const response = await fetch(signedUrl);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      // Return the file data as a Blob
      return await response.blob();
    } catch (error) {
      console.error("Error fetching the file:", error);
      setError(error.message);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return { fetchFile, loading, error };
}

export default useFileFetcher;